module.exports = __webpack_public_path__ + "img/좌측평생도메인배너.55fbb389.png";